import { StylesConfig } from 'react-select'

type MyOptionType = {
  label: JSX.Element | string
  value: string
}

type IsMulti = boolean

export const customStyles: StylesConfig<MyOptionType, IsMulti> = {
  option: (provided: any, state) => ({
    ...provided,
    padding: 10,
    ':hover': {
      background: '#F6F7FB',
      color: '#122B46',
    },
    width: '100%',
    backgroundColor: state.isSelected ? '#122B46' : 'white',
    color: state.isSelected ? '#fff' : '#122B46',
    textTransform: 'capitalize',
    fontSize: 14,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  control: (styles) => ({
    ...styles,
    backgroundColor: 'transparent',
    padding: '5px 10px',
    border: 0,
    width: '100%',
    boxShadow: 'none',
    borderRadius: '0.5rem',
  }),
  valueContainer: (provided) => ({
    ...provided,
    borderRadius: '0.5rem',
    width: '100%',
    boxShadow: '10, 10, 10, black',
    justifyContent: 'start',
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: 13,
    fontWeight: 400,
    color: '#122b4680',
    padding: 0,
  }),
  // selector view
  singleValue: (provided, state) => {
    const transition = 'opacity 300ms'
    return {
      ...provided,
      transition,
      fontSize: 14,
      fontWeight: 400,
      display: 'inline',
      color: state.isDisabled ? '#122b46' : provided.color,
      opacity: state.isDisabled ? '1' : provided.opacity,
      margin: 0,
    }
  },
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#122B4680',
    display: state.isDisabled ? 'none' : '',
  }),
  menuList: (provided) => ({
    ...provided,
    overflowX: 'hidden',
    overflowY: 'auto',
    fontSize: 14,
    paddingTop: '0px',
    paddingBottom: '0px',
    boxShadow: 'none',
    borderRadius: '0px 0px 8px 8px',
    zIndex: 999,
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '0px 0px 8px 8px',
    marginTop: '0px',
    boxShadow: 'none',
    border: '1px solid #1f41731a',
    width: 'calc(100% + 2px)',
    left: '-1px',
  }),
  input: (provided) => ({
    ...provided,
    fontSize: 14,
    ':focus': {
      backgroundColor: '#8b0b316e',
    },
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#FEF5F6',
    alignItems: 'center',
    borderRadius: '5px',
    padding: '3px',
    paddingLeft: '8px',
    paddingRight: '8px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#F70763',
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: '#ccc',
    svg: {
      transition: '0.2s linear',
    },
    ':hover': {
      backgroundColor: 'transparent',
    },
    ':hover svg': {
      color: '#F70763',
    },
    display: state.isDisabled ? 'none' : 'block',
  }),
}

export const registerCustomStyles: StylesConfig<MyOptionType, IsMulti> = {
  ...customStyles,
  container: (provided) => ({
    ...provided,
    height: '100%',
  }),
  control: (provided, state) => ({
    ...provided,
    ...customStyles.control,
    height: '100%',
    padding: '5px 0',
    border: 0,
    width: '100%',
    boxShadow: 'none',
    borderRadius: '0.5rem',
    backgroundColor: state.hasValue ? 'transparent' : '#00000005',
    color: '#00000050',
    cursor: 'pointer',
    textDecoration: state.hasValue ? 'none' : 'underline',
    ':hover': {
      textDecoration: 'none',
    },
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    ...customStyles.valueContainer,
    justifyContent: state.hasValue ? 'start' : 'center',
  }),
  placeholder: (provided) => ({
    ...provided,
    ...customStyles.placeholder,
    fontSize: 12,
    color: 'inherit',
    textDecoration: 'inherit',
  }),
}

export const customStyles_: StylesConfig<MyOptionType, IsMulti> = {
  option: (provided: any, state: any) => ({
    ...provided,
    padding: '10px',
    ':hover': {
      background: '#F6F7FB',
      color: '#122B46',
    },
    width: '100%',
    backgroundColor: state.isSelected ? '#122B46' : 'white',
    color: state.isSelected ? '#fff' : '#122B46',
    textTransform: 'capitalize',
    fontSize: 14,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  control: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: 'transparent',
    padding: 5,
    border: 0,
    width: '100%',
    boxShadow: 'none',
    color: state.isSelected ? '#122B46' : '#122B4680',
    borderRadius: '0.5rem',
    height: '51px',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    borderRadius: '0.5rem',
    width: '100%',
    boxShadow: '10, 10, 10, black',
    justifyContent: 'start',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontSize: 14,
    fontWeight: 400,
    color: '#122b4680',
  }),
  // selector view
  singleValue: (provided: any, state: any) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 300ms'
    return {
      ...provided,
      opacity,
      transition,
      color: '#122B46',
      fontSize: 14,
      fontWeight: 400,
      display: 'inline',
    }
  },
  menuList: (provided: any) => ({
    ...provided,
    overflowX: 'hidden',
    overflowY: 'auto',
    fontSize: 14,
    paddingTop: '0px',
    paddingBottom: '0px',
    boxShadow: 'none',
    borderRadius: '0px 0px 8px 8px',
    zIndex: 999,
    maxHeight: '220px',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '0px 0px 8px 8px',
    marginTop: '0px',
    boxShadow: 'none',
    border: '1px solid #1f41731a',
    width: 'calc(100% + 2px)',
    left: '-1px',
  }),
  input: (provided: any) => ({
    ...provided,
    fontSize: 14,
    ':focus': {
      backgroundColor: '#8b0b316e',
    },
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: '#122B4680',
  }),
}

export const HeightRestOptions: MyOptionType[] = [
  {
    label: <span className="leading-4">5.0</span>,
    value: '5.0',
  },
  {
    label: <span className="leading-4">5.1</span>,
    value: '5.1',
  },
  {
    label: <span className="leading-4">5.2</span>,
    value: '5.2',
  },
  {
    label: <span className="leading-4">5.3</span>,
    value: '5.3',
  },
  {
    label: <span className="leading-4">6.0</span>,
    value: '6.0',
  },
  {
    label: <span className="leading-4">6.1</span>,
    value: '6.1',
  },
  {
    label: <span className="leading-4">6.2</span>,
    value: '6.2',
  },
  {
    label: <span className="leading-4">6.3</span>,
    value: '6.3',
  },
  {
    label: <span className="leading-4">7.0</span>,
    value: '7.0',
  },
  {
    label: <span className="leading-4">7.1</span>,
    value: '7.1',
  },
  {
    label: <span className="leading-4">7.2</span>,
    value: '7.2',
  },
  {
    label: <span className="leading-4">7.3</span>,
    value: '7.3',
  },
  {
    label: <span className="leading-4">8.0</span>,
    value: '8.0',
  },
  {
    label: <span className="leading-4">8.1</span>,
    value: '8.1',
  },
  {
    label: <span className="leading-4">8.2</span>,
    value: '8.2',
  },
  {
    label: <span className="leading-4">8.3</span>,
    value: '8.3',
  },
  {
    label: <span className="leading-4">9.0</span>,
    value: '9.0',
  },
  {
    label: <span className="leading-4">9.1</span>,
    value: '9.1',
  },
  {
    label: <span className="leading-4">9.2</span>,
    value: '9.2',
  },
  {
    label: <span className="leading-4">9.3</span>,
    value: '9.3',
  },
  {
    label: <span className="leading-4">10.0</span>,
    value: '10.0',
  },
  {
    label: <span className="leading-4">10.1</span>,
    value: '10.1',
  },
  {
    label: <span className="leading-4">10.2</span>,
    value: '10.2',
  },
  {
    label: <span className="leading-4">10.3</span>,
    value: '10.3',
  },
  {
    label: <span className="leading-4">11.0</span>,
    value: '11.0',
  },
  {
    label: <span className="leading-4">11.1</span>,
    value: '11.1',
  },
  {
    label: <span className="leading-4">11.2</span>,
    value: '11.2',
  },
  {
    label: <span className="leading-4">11.3</span>,
    value: '11.3',
  },
  {
    label: <span className="leading-4">12.0</span>,
    value: '12.0',
  },
  {
    label: <span className="leading-4">12.1</span>,
    value: '12.1',
  },
  {
    label: <span className="leading-4">12.2</span>,
    value: '12.2',
  },
  {
    label: <span className="leading-4">12.3</span>,
    value: '12.3',
  },
  {
    label: <span className="leading-4">13.0</span>,
    value: '13.0',
  },
  {
    label: <span className="leading-4">13.1</span>,
    value: '13.1',
  },
  {
    label: <span className="leading-4">13.2</span>,
    value: '13.2',
  },
  {
    label: <span className="leading-4">13.3</span>,
    value: '13.3',
  },
  {
    label: <span className="leading-4">14.0</span>,
    value: '14.0',
  },
  {
    label: <span className="leading-4">14.1</span>,
    value: '14.1',
  },
  {
    label: <span className="leading-4">14.2</span>,
    value: '14.2',
  },
  {
    label: <span className="leading-4">14.3</span>,
    value: '14.3',
  },
  {
    label: <span className="leading-4">15.0</span>,
    value: '15.0',
  },
  {
    label: <span className="leading-4">15.1</span>,
    value: '15.1',
  },
  {
    label: <span className="leading-4">15.2</span>,
    value: '15.2',
  },
  {
    label: <span className="leading-4">15.3</span>,
    value: '15.3',
  },
  {
    label: <span className="leading-4">16.0</span>,
    value: '16.0',
  },
  {
    label: <span className="leading-4">16.1</span>,
    value: '16.1',
  },
  {
    label: <span className="leading-4">16.2</span>,
    value: '16.2',
  },
  {
    label: <span className="leading-4">16.3</span>,
    value: '16.3',
  },
  {
    label: <span className="leading-4">17.0</span>,
    value: '17.0',
  },
  {
    label: <span className="leading-4">17.1</span>,
    value: '17.1',
  },
  {
    label: <span className="leading-4">17.2</span>,
    value: '17.2',
  },
  {
    label: <span className="leading-4">17.3</span>,
    value: '17.3',
  },
  {
    label: <span className="leading-4">18.0</span>,
    value: '18.0',
  },
  {
    label: <span className="leading-4">18.1</span>,
    value: '18.1',
  },
  {
    label: <span className="leading-4">18.2</span>,
    value: '18.2',
  },
  {
    label: <span className="leading-4">18.3</span>,
    value: '18.3',
  },
  {
    label: <span className="leading-4">19.0</span>,
    value: '19.0',
  },
  {
    label: <span className="leading-4">19.1</span>,
    value: '19.1',
  },
  {
    label: <span className="leading-4">19.2</span>,
    value: '19.2',
  },
  {
    label: <span className="leading-4">19.3</span>,
    value: '19.3',
  },
  {
    label: <span className="leading-4">20+</span>,
    value: '20+',
  },
]

export const SexRestOptions: MyOptionType[] = [
  {
    value: 'Mare',
    label: 'Mare',
  },
  {
    value: 'Gelding',
    label: 'Gelding',
  },
  {
    value: 'Stallion',
    label: 'Stallion',
  },
]

export const geldingStatusOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
]

export const MeasurementCardTypeRestOptions: MyOptionType[] = [
  {
    value: 'primary',
    label: (
      <span className="leading-4">
        <img
          src="/assets/og_icons/Ruler Vertical-1.svg"
          className="inline mr-4"
          height="16px"
          width="16px"
          alt="ruler"
        />
        Primary
      </span>
    ),
  },
  {
    value: 'secondry',
    label: (
      <span className="leading-4">
        <img
          src="/assets/og_icons/Ruler Vertical-1.svg"
          className="inline mr-4"
          height="16px"
          width="16px"
          alt="ruler"
        />
        Secondry
      </span>
    ),
  },
]
